export default `
  mutation updateProjectOwner($projectId: String!, $userId: String!) {
    updateProjectOwner(projectId: $projectId, userId: $userId) {
      id
      name
      organisationId
      organisation {
        id
        name
        userId
        user {
          id
          firstname
          lastname
        }
        createdAt
      }
    }
  }
`
